import { gql } from 'apollo-boost'


export const GENERATE_ACCESS_TOKEN = gql`
query{
    generateAccessToken
}`